module.exports = __webpack_public_path__ + "img/icon_society.2e8fe0a8.jpg";